<template>
  <div>
    <b-row>
      <b-col class="pr-0">
        <p class="mb-0">
          <b-button variant="outline-branded" size="sm" :disabled="busy" @click="onClickPrevious">
            <i class="fa fa-fw fa-chevron-left"></i>
          </b-button>
          <date-picker v-model="date" :config="dateConfig" :disabled="busy">
            <span class="lead">{{ dateRange }}</span>
            <i class="fa fa-fw fa-caret-down"></i>
          </date-picker>
          <b-button variant="outline-branded" size="sm" :disabled="busy" @click="onClickNext">  
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </p>
      </b-col>
      <b-col class="col-auto pl-0">
        <b-button 
          v-if="!!this.organization.auth_user"
          variant="outline-branded"
          size="sm"
          class="d-none d-sm-inline-block"
          :disabled="busy"
          @click="fetchAvailabilities"
        >
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
        <b-form-radio-group
          v-model="view"
          :options="viewOptions"
          :disabled="busy"
          buttons
          button-variant="outline-branded"
          size="sm"
          @input="fetchAvailabilities"
        ></b-form-radio-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-overlay :opacity="0.3" :show="busy">
          <calendar
            :organization="organization"
            :view="view"
            :dates="dates"
            :availabilities="availabilities"
            sort-column="order"
            show-title
            @click-avail="onClickAvail"
          ></calendar>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Calendar from './Calendar'
  import querystring from 'querystring'
  import DatePicker from './../../../common/components/DatePicker'

  function parseView(v) {
    if (v == 'dayGridWeek') return '7d'
    if (v == 'fourDayGrid') return '4d'
    return v
  }

  export default {
    props: {
      organization: Object,
      package_category: Object,
      invoice: Object,
      page: String,
    },
    components: {
      Calendar,
      DatePicker,
    },
    data() {
      let query = querystring.parse(window.location.search.substring(1))
      let date = moment(query.d || undefined)
      if (!date.isValid()) date = moment()
      return {
        trans: trans,
        lang: lang,
        moment: moment,
        querystring: querystring,
        busy: false,
        error: false,
        view: parseView(query.v) || '4d', // 1d, 2d, ..., 7d
        date: date.format('YYYY-MM-DD'),
        dateConfig: {
          locale: window.lang,
          format: 'YYYY-MM-DD',
          showTodayButton: true,
        },
        availabilities: null,
      }
    },
    computed: {
      dates() {
        let days = 1
        if (this.view == 'dayGridWeek') days = 7
        else if (this.view == 'fourDayGrid') days = 4
        else {
          const matches = this.view.match(/([0-9])d/)
          if (matches && matches.length >= 2) days = parseInt(matches[1], 10)
        }
        let dates = []
        let date = moment(this.date, 'YYYY-MM-DD')
        for (let i = 0; i < days; i++) {
          dates.push(date.format('YYYY-MM-DD'))
          date.add(1,'day')
        }
        return dates
      },
      start() {
        return this.dates[0]
      },
      end() {
        return this.dates[this.dates.length-1]
      },
      days() {
        return this.dates.length
      },
      dateRange() {
        return _.dateRangeStr(moment(this.start), moment(this.end), true)
      },
      viewOptions() {
        let views = ['4d', '2d', '5d', '7d']
        if (views.indexOf(this.view) === -1) views.push(this.view)
        views.sort()
        return _.map(views, v => {
          return {
            text: window.lang == 'fr' ? v.replace('d', 'j') : v,
            value: v
          }
        })
      },
      reservations() {
        if (!this.invoice) return {}
        return _.reduce(this.invoice.invoice_items, (reservations, item) => {
          if (item.package_id) {
            const key = item.package_id + '.' + item.start
            reservations[key] = item
          }
          return reservations
        }, {})
      },
      query() {
        return `?d=${this.date}&v=${this.view}&p=${this.page}`
      },
    },
    watch: {
      date() {
        this.fetchAvailabilities()
      },
      invoice(newCart, oldCart) {
        if (_.isEqual(newCart, oldCart) ||
          !oldCart && newCart && newCart.invoice_items.length == 0)
          return
        this.$nextTick(this.fetchAvailabilities)
      },
      page() {
        this.persistInUrl()
      },
    },
    methods: {
      onClickPrevious() {
        this.date = moment(this.start, 'YYYY-MM-DD').add(-this.days, 'day').format('YYYY-MM-DD')
      },
      onClickNext() {
        this.date = moment(this.end, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')
      },
      onClickAvail(e, event) {
        console.log('onClickAvail', event.id, event.extendedProps.package_name)
      },
      fetchAvailabilities() {
        this.busy = true
        let start = moment(this.start).toISOString()
        let end = moment(this.end).add(1, 'day').toISOString()
        let url = `/org/${this.organization.id}/packages/${this.package_category.id}/availability?start=${encodeURIComponent(this.start)}&end=${encodeURIComponent(this.end)}`
        axios.get(url)
        .then(response => {
          this.availabilities = response.data
          this.persistInUrl()
          this.busy = false
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      persistInUrl() {
        window.history.replaceState(null, null, window.location.href.split('?')[0] + this.query)
        this.$emit('url-change')
      },
    },
    mounted() {
      window.packageCategoryCalendar = this
      this.fetchAvailabilities()
    },
  }
</script>